module.exports = __webpack_public_path__ + "img/logo.402d5e1.png";